import { render, staticRenderFns } from "./PlanSelect.vue?vue&type=template&id=35ee5a2c&"
import script from "./PlanSelect.vue?vue&type=script&lang=ts&"
export * from "./PlanSelect.vue?vue&type=script&lang=ts&"
import style0 from "./PlanSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports